module.exports = __webpack_public_path__ + "fonts/icons.a73d044.eot";